import { useEffect, useState } from 'react';
import { Guild } from '@/network/RestApi';
import { useCharacterStore } from '@/state/characterStore';
import { useUIStore } from '@/state/uiStore';
import { ui } from './theme';
import { CloseButton } from './CloseButton';

interface GuildMember { characterId: number; role: string }
interface GuildDetail { id: number; name: string; level: number; notice?: string; masterId?: number; members?: GuildMember[] }

export function GuildPanel() {
  const ch = useCharacterStore((s) => s.current);
  const setCurrent = useCharacterStore((s) => s.setCurrent);
  const close = () => useUIStore.getState().set('guild', false);
  const [g, setG] = useState<GuildDetail | null>(null);
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const showToast = useUIStore((s) => s.showToast);

  const gid = ch?.guildId ?? null;

  useEffect(() => {
    if (!gid) { setG(null); return; }
    Guild.detail(gid).then((r) => setG(r as GuildDetail)).catch(() => setG(null));
  }, [gid]);

  const create = async () => {
    if (!name.trim() || !ch || loading) return;
    setLoading(true);
    try {
      const r = await Guild.create({ name, characterId: ch.id });
      showToast('Tạo guild OK');
      setCurrent({ ...ch, guildId: r.id });
    } catch (e) {
      showToast((e as Error).message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'absolute', top: 70, right: 340, width: 320, ...ui.panel }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <strong>Guild</strong>
        <CloseButton onClick={close} />
      </div>
      {g ? (
        <>
          <div>{g.name} (Lv {g.level})</div>
          {g.notice && <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>{g.notice}</div>}
          <ul style={{ paddingLeft: 16, marginTop: 8 }}>
            {(g.members ?? []).map((m) => <li key={m.characterId}>#{m.characterId} - {m.role}</li>)}
          </ul>
        </>
      ) : gid ? (
        <div style={{ fontSize: 12, opacity: 0.7 }}>Đang tải guild #{gid}...</div>
      ) : (
        <div>
          <p style={{ fontSize: 12, opacity: 0.7 }}>Chưa thuộc guild. Tạo mới:</p>
          <input style={ui.input} placeholder="Tên guild" value={name} onChange={(e) => setName(e.target.value)} />
          <button style={{ ...ui.primaryBtn, marginTop: 8 }} disabled={loading} onClick={create}>Tạo guild</button>
        </div>
      )}
    </div>
  );
}
